/*
 jQuery AJAX Cross Origin v1.3 (http://www.ajax-cross-origin.com) 
 jQuery plugin to bypass Same-origin_policy using Google Apps Script. 
 
 references:
 http://en.wikipedia.org/wiki/Same-origin_policy
 http://www.google.com/script/start/
 
 (c) 2014, Writen by Erez Ninio. site: www.dealhotelbook.com
 
 Licensed under the Creative Commons Attribution 3.0 Unported License. 
 For details, see http://creativecommons.org/licenses/by/3.0/.
*/

var proxyJsonp =
  "http://script.google.com/macros/s/AKfycbwmqG55tt2d2FcT_WQ3WjCSKmtyFpkOcdprSITn45-4UgVJnzp9/exec";
jQuery.ajaxOrig = jQuery.ajax;
jQuery.ajax = function(a, b) {
  function d(a) {
    a = encodeURI(a).replace(/&/g, "%26");
    return proxyJsonp + "?url=" + a + "&callback=?";
  }
  var c = "object" === typeof a ? a : b || {};
  c.url = c.url || ("string" === typeof a ? a : "");
  var c = jQuery.ajaxSetup({}, c),
    e = (function(a, c) {
      var b = document.createElement("a");
      b.href = a;
      return (
        c.crossOrigin &&
        "http" == a.substr(0, 4).toLowerCase() &&
        "localhost" != b.hostname &&
        "127.0.0.1" != b.hostname &&
        b.hostname != window.location.hostname
      );
    })(c.url, c);
  c.proxy &&
    0 < c.proxy.length &&
    ((proxyJsonp = c.proxy),
    "object" === typeof a
      ? (a.crossDomain = !0)
      : "object" === typeof b && (b.crossDomain = !0));
  e &&
    ("object" === typeof a
      ? a.url &&
        ((a.url = d(a.url)),
        a.charset && (a.url += "&charset=" + a.charset),
        (a.dataType = "json"))
      : "string" === typeof a &&
        "object" === typeof b &&
        ((a = d(a)),
        b.charset && (a += "&charset=" + b.charset),
        (b.dataType = "json")));
  return jQuery.ajaxOrig.apply(this, arguments);
};
jQuery.ajax.prototype = new jQuery.ajaxOrig();
jQuery.ajax.prototype.constructor = jQuery.ajax;

/* Channel Islands v4.0.0 by @sltwtr
 * Copyright 2014 Sltwtr
 * Licensed under http://www.apache.org/licenses/LICENSE-2.0
 *
 * Applied Creativity by @sltwtr.
 */
//DEBUG
var DEBUG = false;
console.log("Channel Islands Surfboards Website v4.0");

// window.shopify_shop_url = regional_partner.shopify_shop_url;
// window.shopify_api_url = regional_partner.shopify_api_url;
// handle Australia checking here to modify

function clog(drain) {
  if (DEBUG == true) {
    console.log(drain);
  }
}

function changeSelect(el, value) {
  programatic_change = true;
  el.val(value);
  el.find("option").each(function() {
    if ($(this).attr("value") == value) {
      $(this).attr("selected", true);
    } else {
      $(this).removeAttr("selected");
    }
  });
  el.change().trigger("change");
  programatic_change = false;
}

/************  UX FUNCTIONS  ***************/

function set_dim_lines($user_dims) {
  var $thisboard = $user_dims.parents(".this-board");

  var bid = $thisboard.data("bid");

  var dimlength = $thisboard.find(".select-length").val();
  var dimwidth = $thisboard.find(".select-width").val();

  if ($("body").hasClass("compare-surfboards")) {
    // length
    $thisboard.find(".dim-value-length").text(feet(dimlength));
    // width
    $thisboard.find(".dim-value-width").text(fraction(dimwidth));

    var tail = "squash";
    if ($user_dims.data("sd") == 587) tail = "";

    // nose width
    $.post(
      "https://www.shape3d.com/api/width",
      {
        board: $user_dims.data("sd"),
        length: dimlength,
        width: dimwidth,
        variation: tail,
        prec: "1/16",
        position: dimlength - 12,
        unite: "IF",
      },
      function(data) {
        $thisboard.find(".dim-value-nose-width").text(data.replace('"', ""));
      }
    );
    // tail width
    $.post(
      "https://www.shape3d.com/api/width",
      {
        board: $user_dims.data("sd"),
        length: dimlength,
        width: dimwidth,
        variation: tail,
        prec: "1/16",
        position: 12,
        unite: "IF",
      },
      function(data) {
        console.log(data);
        $thisboard.find(".dim-value-tail-width").text(data.replace('"', ""));
      }
    );
  }

  if ($("body").hasClass("template-surfboards")) {
    // nose rocker
    $.post(
      "https://www.shape3d.com/api/rocker",
      {
        board: $user_dims.data("sd"),
        length: dimlength,
        prec: "1/16",
        position: dimlength, //distance from tail
        unite: "IF",
      },
      function(data) {
        console.log(data);
        $thisboard.find(".nose-rocker").text(data.replace('"', ""));
      }
    );

    /// nose rocker
    $.post(
      "https://www.shape3d.com/api/rocker",
      {
        board: $user_dims.data("sd"),
        length: dimlength,
        prec: "1/16",
        position: 0, //distance from tail
        unite: "IF",
      },
      function(data) {
        console.log(data);
        $thisboard.find(".tail-rocker").text(data.replace('"', ""));
      }
    );
  }
}

/* ***********************
	RESPONSIVE DETECTION
*********************** */
function isMobile(t, f, w) {
  w = w || 991;
  t = t || true;
  f = f || false;
  if ($(window).width() < w) {
    return t;
  } else {
    return f;
  }
}

function bsState(xs, sm, md, lg) {
  if (typeof xs === "undefined") {
    xs = "xs";
  }
  if (typeof sm === "undefined") {
    sm = "sm";
  }
  if (typeof md === "undefined") {
    md = "md";
  }
  if (typeof lg === "undefined") {
    lg = "lg";
  }
  var envs = ["xs", "sm", "md", "lg"],
    rets = [xs, sm, md, lg],
    doc = window.document,
    temp = doc.createElement("div");
  doc.body.appendChild(temp);
  for (var i = envs.length - 1; i >= 0; i--) {
    var env = envs[i];
    temp.className = "hidden-" + env;
    if (temp.offsetParent === null) {
      doc.body.removeChild(temp);
      return rets[i];
    }
  }
  return "";
}

function resizedw() {
  $(window).trigger("changeState");
}
var doit;
window.onresize = function() {
  clearTimeout(doit);
  doit = setTimeout(resizedw, 400);
};

function isMobileDevice() {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    return true;
  } else {
    return false;
  }
}
if (isMobileDevice()) {
  $("body").addClass("mobile-device");
}

function fancy_selects() {
  if (
    $(
      "select[name='cilist'],select.fancy,select[name='board-select-1'],select[name='board-select-2'],select[name='board-select-3'],select.custtext"
    ).length > 0
  ) {
    //$("select.custtext").addClass("btn-inverse");
    $(
      "select[name='cilist'],select.fancy,select[name='board-select-1'],select[name='board-select-2'],select[name='board-select-3'],select.custtext"
    ).selectpicker({
      menuStyle: "dropdown-inverse",
    });
    $("select:not(.not-fancy)").trigger("change");
  }
  $(".select-group.user-dims").show();
}

/// SUGGESTED DIMS
function updateDims() {
  $.post(
    "/wp-content/themes/ci/lib/ci/suggested_dims.php",
    {
      action: "get_suggested_dims",
      is_json: true,
      weight: $(".profile-header select#weight").val(),
      ability: $(".profile-header select#ability").val(),
    },
    function(data) {
      $(".user-dims").each(function() {
        var boards = data.data;

        var model = $(this).data("model");
        var board = boards[model];

        if (board) {
          console.log("board", board);
          changeSelect(
            $(this).find("select.select-length"),
            board.dimlength.toString()
          );
          changeSelect(
            $(this).find("select.select-width"),
            board.dimwidth.toString()
          );
          changeSelect(
            $(this).find("select.select-thickness"),
            board.dimthickness.toString()
          );
          $(this)
            .find(".field-volume")
            .val(board.volume.toString() + " L");
          $(this)
            .find(".field-volume")
            .text(board.volume.toString() + " L");

          set_dim_lines($(this));
        }
      });
    },
    "json"
  );
}

function isIE(v) {
  var r = RegExp("msie" + (!isNaN(v) ? "\\s" + v : ""), "i");
  return r.test(navigator.userAgent);
}

function supports_html5_storage() {
  try {
    return "localStorage" in window && window["localStorage"] !== null;
  } catch (e) {
    return false;
  }
}

function feet(inches) {
  var feet = Math.floor(inches / 12);
  inches %= 12;
  return feet + "'" + inches;
}

function fraction(decimal) {
  if (!decimal) {
    decimal = this;
  }
  var whole = String(decimal).split(".")[0];
  decimal = parseFloat("." + String(decimal).split(".")[1]);
  var num = "1";
  for (var z = 0; z < String(decimal).length - 2; z++) {
    num += "0";
  }
  decimal = decimal * num;
  num = parseInt(num);
  for (var z = 2; z < decimal + 1; z++) {
    if (decimal % z == 0 && num % z == 0) {
      decimal = decimal / z;
      num = num / z;
      z = 2;
    }
  }
  if (decimal) {
    return (whole == 0 ? "" : whole + " ") + decimal + "/" + num;
  } else {
    return whole;
  }
}

function decimal(fraction) {
  var fractionParts = fraction.split(" ");

  if (fractionParts[0].indexOf("/") !== -1) {
    // first node is feet, convert to inches and add to second node(inches), return inches only (no fraction)
  }

  if (fractionParts.length > 1 && fraction.indexOf("/") !== -1) {
    var integer = parseInt(fractionParts[0]);
    var decimalParts = fractionParts[1].split("/");
    var decimal = parseInt(decimalParts[0]) / parseInt(decimalParts[1]);

    return integer + decimal;
  } else if (fraction.indexOf("/") !== -1) {
    var decimalParts = fraction.split("/");
    var decimal = parseInt(decimalParts[0]) / parseInt(decimalParts[1]);
    return decimal;
  } else {
    return parseInt(fraction);
  }
}



// // Shopify Import adjustment
// nav_import.listeners();
// nav_import.transport();

$(function() {
  var programatic_change = false;

  if ($("body").hasClass("single-board")) {
    updateDims();
  }

  // -----------------------------------------------------
  // SELECTS
  // -----------------------------------------------------

  // fancy_selects();

  // try putting this at the top
  //$(function() {

  // -----------------------------------------------------
  // BROWSER HEIGHT
  // -----------------------------------------------------

  $(".full-height").height($(window).height());
  $(".half-height").height($(window).height() / 2);
  $(".most-height").height($(window).height() - $("header.navbar").height());
  $(".half-most-height").height(
    ($(window).height() - $("header.navbar").height()) / 2
  );

  $(".page-height").height(
    $(window).height() -
      $("header.navbar").height() -
      $("#global_container > footer").height()
  );

  // -----------------------------------------------------
  // SWITCH
  // -----------------------------------------------------

  $(".switch").on("click", function() {
    $(this).toggleClass("switch-on");
  });

  // -----------------------------------------------------
  // BUTTON ACTIVE
  // -----------------------------------------------------

  $(".btn-click").on("click", function() {
    $(this).toggleClass("btn-active");
  });

  $(".share-group .btn-click").on("click", function() {
    $(this)
      .siblings(".share-btns")
      .toggleClass("share-active");
    $.get("http://cisurfboards.com/Q/q2.php?q=" + $("body").data("user"));
  });

  /*
    	$('.dropdown-toggle').each(function(){
    		$(this).next('ul').width($(this).width());
    	});
    */
  // -----------------------------------------------------
  // PARENT WIDTH
  // -----------------------------------------------------

  $(".parent-width").width(
    $(this)
      .parent()
      .width()
  );

  // -----------------------------------------------------
  // NAV
  // -----------------------------------------------------

  $(".nav > li.dropdown > a").on("click", function(e) {
    if (isMobile()) {
      e.preventDefault();
      $(this)
        .parents("li.dropdown")
        .toggleClass("active");
    }
  });

  // -----------------------------------------------------
  // LOAD BG IMAGES
  // * Put an image inside of a div and give it data-bg="img"
  // and it will pull the url from that image, otherwise put
  // the url of an image in the data-bg attribute. @sltwtr
  // -----------------------------------------------------
  function data_bg() {
    $("[data-bg]").each(function(i, e) {
      var $bg = $(this);
      var bg;
      if ($(this).data("bg") == "img") {
        bg = $(this)
          .find("img")
          .attr("src");
        $(this)
          .find("img")
          .remove();
      } else {
        bg = $(this).data("bg");
      }
      var $img = $("<img>", {
        src: bg,
      })
        .appendTo(e)
        .load(function() {
          $(this).remove();
          $bg.css({
            "background-image": "url(" + bg + ")",
          });
          $bg.fadeIn("slow");
        });
    });
  }
  data_bg();

  // -----------------------------------------------------
  // SURFBOARDS
  // -----------------------------------------------------

  //--------------------------------------------------
  // Surfboard Selects
  //--------------------------------------------------
  // BUY ONLINE

  var buy_online = {
    init: function() {
      buy_online.enable_product_cat_dropdowns();
      // why timeout?
      setTimeout(buy_online.enable_product_cat_dropdowns(), 1000);
    },
    enable_product_cat_dropdowns: function() {
      $(".mwrc-product-category").each(function() {
        var $buyOnlineSelect = $(this);
        var $buyOnlineButton = $buyOnlineSelect.find(".dropdown-toggle");
        var $buyOnlineDropdown = $buyOnlineSelect.find(".dropdown-menu");

        $buyOnlineButton.on("click", function() {
          var categoryId = $(this).data("category");
          var collectionHandle = $(this).data("collection");

          if (!$(this).hasClass("filled") && !$(this).hasClass("filling")) {
            $(this).addClass("filling");

            if ($(this).hasClass("length-specific")) {
              var board_specs_text = $(this)
                .parents(".quiver-details")
                .find(".quver-board-specs")
                .text();
              console.log(board_specs_text);
              var board_length = board_specs_text.trim().split(" ");
              console.log(board_length);
              buy_online.loadProductsIntoSelect(
                collectionHandle,
                $buyOnlineDropdown,
                $buyOnlineButton,
                board_length
              );
            } else {
              buy_online.loadProductsIntoSelect(
                collectionHandle,
                $buyOnlineDropdown,
                $buyOnlineButton
              );
            }
          }
        });
      });
    },
    loadProductsIntoSelect: function(
      collectionHandle,
      $select,
      $button,
      board_length
    ) {
      var shopifyProductsURL =
        shopify_shop_url + "collections/" + collectionHandle + "/products.json";
      $.ajax({
        method: "GET",
        url: shopifyProductsURL,
        contentType: "application/json; charset=utf-8",
        dataType: "jsonp",
        success: function(data, status) {
          buy_online.add_products_to_list(data, $select, $button);
        },
        error: function(request, status, error) {
          clog("Error:" + request.statusText + " " + error);
          buy_online.show_none_available($button);
        },
      });
    },
    add_products_to_list: function(data, $select, $button) {
      $button.addClass("filled");
      //var products = data.data;
      var products = data.products;
      console.log("products: ", products);
      var i = 0;
      if (Object.keys(products).length) {
        $.each(products, function(index, pInfo) {
          var instock = false;
          for (var i = 0; i < pInfo.variants.length; i++) {
            var this_variant = pInfo.variants[i];
            console.log("this_variant.available: ", this_variant.available);
            if (this_variant.available) {
              instock = true;
            }
          }
          if (instock) {
            i++;
            var productLi =
              '<li class="clearfix has-image" style="display:none" rel="' +
              i +
              '">';
            productLi +=
              '<a tabindex="-1" href="' +
              shopify_shop_url +
              "products/" +
              pInfo.handle +
              '">';
            productLi += '<span class="dropdown-span whs-board">';
            productLi += '<img src="' + pInfo.images[0].src + '">';
            productLi += "</span>";
            productLi += '<span class="dropdown-span whs-details">';
            productLi += pInfo.title + "<br />" + pInfo.variants[0].price;
            productLi += "</span>";
            productLi += '<span class="dropdown-span whs-liter">';
            productLi += "";
            productLi += "</span></a></li>";
            //$(productLi).appendTo($buyOnlineDropdown).delay(i*200).fadeIn(1000);
            $(productLi)
              .appendTo($select)
              .show();
          }
        });
      } else {
        buy_online.show_none_available($button);
      }
    },
    show_none_available: function($button, $buyOnlineDropdown) {
      $buyOnlineDropdown = $buyOnlineDropdown
        ? $buyOnlineDropdown
        : $(".block-dropdown.ecommerce .dropdown-menu");
      $button.addClass("filled");
      var productLi =
        '<li class="clearfix has-image" style="display:none" rel="">';
      productLi += '<a tabindex="-1" href="">';
      productLi += '<span class="dropdown-span whs-details">';
      productLi += "None Available";
      productLi += "</span>";
      productLi += "</a></li>";

      // $buyOnlineDropdown.css('height', 'auto');
      $(productLi)
        .appendTo($buyOnlineDropdown)
        .show();
    },
  };

  buy_online.init();

  // WAREHOUSE STOCK
  var $warehouseStockSelect = $(".single-specs-wrapper #warehouse-stock-div");
  var $warehouseStockButton = $warehouseStockSelect.find(".dropdown-toggle");
  var $warehouseStockDropdown = $warehouseStockSelect.find(".dropdown-menu");

  $warehouseStockButton.on("click", function() {
    var dimsId = $(this).data("dims-id");
    if (!$(this).hasClass("filled")) {
      loadWarehouseProductsIntoSelect(dimsId);
    }
  });

  function loadWarehouseProductsIntoSelect(dimsId) {
    var productsURL =
      "/wp-content/themes/ci/lib/ci/warehouse_stock.php?region=" +
      regional_partner.partner_id +
      "&board_id=" +
      dimsId;
    $.ajax({
      method: "GET",
      url: productsURL,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      success: function(data, status) {
        // console.log("success");
        // console.log('data: ', data);

        $warehouseStockButton.addClass("filled");
        var products = data.data;
        var board_name = $(".single-board-title").text();
        var i = 0;
        if (Object.keys(products).length) {
          $.each(products, function(dimsId, pInfo) {
            i++;
            var len_array = pInfo.stockPartNumber.split("-");
            var dimensions =
              len_array[0] +
              " x " +
              pInfo.stockWidth +
              pInfo.stockWidthFraction +
              " x " +
              pInfo.stockThickness +
              pInfo.stockThicknessFraction;
            var productLi =
              '<li class="clearfix no-image" style="display:none" rel="' +
              i +
              '">';
            productLi += '<a tabindex="-1">';
            productLi += '<span class="dropdown-span whs-board">';
            //productLi += '<img src="' + '' +'">';
            productLi += "</span>";
            productLi += '<span class="dropdown-span whs-details">';
            productLi +=
              board_name +
              " " +
              pInfo.stockGeneralDescription +
              "<br />" +
              dimensions;
            productLi += "</span>";
            productLi += '<span class="dropdown-span whs-liter">';
            var wsvolume = pInfo.stockVolume.trim();
            if (wsvolume) {
              wsvolume = parseInt(wsvolume);
              if (wsvolume > 100) {
                wsvolume = wsvolume / 10;
              }
              wsvolume = wsvolume.toFixed(1);
            }
            productLi += wsvolume;
            productLi += "</span></a></li>";
            $(productLi)
              .appendTo($warehouseStockDropdown)
              .show();
          });
          $("#warehouse-stock-div li").on("click", function() {
            $(".modal-warehouse").modal("show");
          });
        } else {
          show_out_of_stock();
        }
      },
      error: function(request, status, error) {
        // console.log("error");
        clog("Error:" + request.statusText + " " + error);
        show_out_of_stock();
      },
    });
  }

  function show_out_of_stock() {
    $warehouseStockButton.addClass("filled");
    var productLi =
      '<li class="clearfix has-image" style="display:none" rel="">';
    productLi += '<a tabindex="-1" href="">';
    productLi += '<span class="dropdown-span whs-details">';
    productLi += "Out Of Stock";
    productLi += "</span>";
    productLi += "</a></li>";
    $warehouseStockDropdown.css("height", "auto");
    $(productLi)
      .appendTo($warehouseStockDropdown)
      .show();
  }

  // -----------------------------------------------------
  // Compare List
  // -----------------------------------------------------
  function setup_compare_functionality() {
    // start with empty
    var ci_compare = [];

    if (supports_html5_storage()) {
      // empty compare
      if (document.location.hash == "#clearcompare") {
        //alert('compare cleared');
        set_compare([]);
      } else {
        compare_button_class_assignment();
        compare_count_notifications();
      }

      // show and click handler
      $(".do-compare")
        .css("display", "inline-block")
        .on("click", function() {
          var ci_compare_list = compare_list();

          var $btn = $(this);
          var $this_board = $btn.parents(".this-board");
          var board_id = $btn.data("board-id");

          //alert($btn.hasClass('btn-active'));

          if (!$btn.hasClass("btn-active")) {
            // add to compare list
            ci_compare_list.push({
              board_id: board_id,
              length: $this_board.find("select.select-length").val(),
              width: $this_board.find("select.select-width").val(),
              thickness: $this_board.find("select.select-thickness").val(),
            });

            //alert('add active class');
            $btn.addClass("btn-active").attr("data-original-title", "Remove");
          } else {
            // remove from compare list
            var to_remove;
            for (var i = 0; i < ci_compare_list.length; i++) {
              if (ci_compare_list[i].board_id == board_id) {
                to_remove = i;
              }
            }
            ci_compare_list.splice(to_remove, 1);

            $btn
              .removeClass("btn-active")
              .attr("data-original-title", "Compare");
          }
          set_compare(ci_compare_list);

          ga("send", "event", "Add to Compare List", "click", "compare");
        });
    }
  } // setup compare functionality
  setup_compare_functionality();

  function set_compare(to_compare) {
    localStorage.setItem("ci_compare", JSON.stringify(to_compare));
    compare_count_notifications();
  }

  function compare_button_class_assignment() {
    var the_compare_list = compare_list();
    // add active class to buttons for any boards in compare list
    if (the_compare_list.length > 0) {
      $.each(the_compare_list, function(i, e) {
        $(".do-compare[data-board-id=" + e.board_id + "]")
          .addClass("btn-active")
          .attr("data-original-title", "Remove");
      });
    }
  }

  function compare_list() {
    if (
      localStorage.getItem("ci_compare") &&
      localStorage.getItem("ci_compare") != null
    ) {
      var ci_compare = JSON.parse(localStorage.getItem("ci_compare"));
      var new_compare = [];
      $.each(ci_compare, function(i, e) {
        if (e.board_id != 209) {
          new_compare.push(e);
        }
      });
      localStorage.setItem("ci_compare", JSON.stringify(new_compare));
    } else {
      ci_compare = [];
    }
    return ci_compare;
  }

  function compare_count_notifications() {
    var ci_compare = compare_list();
    var compare_count = Object.keys(ci_compare).length;
    if (compare_count > 0) {
      $(".notifications .notify-group .compare-count").text(compare_count);
      $(".compare-show").fadeIn(function() {
        // if($.cookie('welcome')=='true') {
        //     intro();
        // }
      });
    } else {
      $(".compare-show").fadeOut();
    }
  }

  $(".compare-show").on("click", function() {
    ga("send", "event", "Compare Submit Button", "click", "compare");
  });

  function modify_compare($board) {
    //alert('modify');
    if ($board.find(".do-compare").hasClass("btn-active")) {
      var ci_compare_list = compare_list();

      var $btn = $board.find(".do-compare");
      var $this_board = $board;
      var board_id = $btn.data("board-id");

      // console.log(board_id);

      for (var i = 0; i < ci_compare_list.length; i++) {
        if (ci_compare_list[i].board_id == board_id) {
          console.log(ci_compare_list[i]);
          ci_compare_list[i].length = $this_board
            .find("select.select-length")
            .val();
          ci_compare_list[i].width = $this_board
            .find("select.select-width")
            .val();
          ci_compare_list[i].thickness = $this_board
            .find("select.select-thickness")
            .val();
        }
      }

      set_compare(ci_compare_list);
    }
  }

  // -----------------------------------------------------
  // Compare View
  // -----------------------------------------------------

  function before_compare() {
    console.log("before compare");

    $(".compare-swiper .swiper-wrapper").empty();
    $(".compare-swiper .swiper-wrapper .swiper-slide").remove();
    $(".show-on-load").hide();
    $(".compare-swiper .loading").fadeIn("fast");
  }

  function load_compare_boards(boards_to_compare) {
    console.log("boards_to_compare", boards_to_compare);
    var added_boards = 0;

    $.each(boards_to_compare, function(i, e) {
      var compareBoard = $("<div/>")
        .addClass("swiper-slide")
        .addClass("this-board")
        .attr("data-index", i);
      compareBoard.appendTo(".compare-swiper .swiper-wrapper");

      var load_url =
        "/wp-content/themes/ci/compare-board.php?bid=" +
        e.board_id +
        "&length=" +
        e.length +
        "&width=" +
        e.width +
        "&thickness=" +
        e.thickness;
      console.log("load_url: ", load_url);

      compareBoard.load(load_url, function() {
        set_dim_lines(compareBoard.find(".user-dims"));

        board_volume(compareBoard.find("select.select-length"));

        added_boards++;
        if (added_boards == boards_to_compare.length) {
          var src = compareBoard.find("img.compare-board-image").attr("src");
          compareBoard
            .find("img.compare-board-image")
            .attr("src", src)
            .one("load", function() {
              var boards = document.querySelectorAll(".compare-board-image");
              imagesLoaded(boards, function() {
                /// @COMPARE
                compare(boards_to_compare);
                /// @COMPARE
              });
            })
            .each(function() {
              if (this.complete) $(this).trigger("load");
            });
        }
      });
    });
  } // load_compare()

  var compareSwiper;
  //var visibleboards = 3;

  function compare(the_boards) {
    console.log("compare", the_boards);

    // console.log('compare');

    compare_layout();

    // REMOVE IF EXISTS
    if (typeof compareSwiper != "undefined") {
      // destroy and delete swiper object
      compareSwiper.destroy();
      compareSwiper = undefined;
      $(".compare-board-view .swiper-container .swiper-wrapper").removeAttr(
        "style"
      );
    }

    if (the_boards.length > isMobile(1, 3)) {
      if (the_boards.length > 2) {
        visibleboards = 3;
      } else {
        visibleboards = 2;
      }

      // INSTANTIATE

      compareSwiper = new Swiper(".compare-swiper", {
        mode: "horizontal",
        loop: false,
        releaseFormElements: true,
        preventClicks: false,
        preventClicksPropagation: false,
        noSwiping: true,
        noSwipingClass: "btn",
        centeredSlides: isMobile(),
        keyboardControl: true,
        mouseControl: true,
        random: 0,
        visibilityFullFit: isMobile(),
        slidesPerView: isMobile("auto", visibleboards),
      });

      $(".compare-arrow").show();
      $(".arrow-left.compare-arrow").on("click", function(e) {
        e.preventDefault;
        compareSwiper.swipePrev();
      });
      $(".arrow-right.compare-arrow").on("click", function(e) {
        e.preventDefault;
        compareSwiper.swipeNext();
      });
    } else {
      $(".compare-arrow").hide();
      $(".compare-arrow").removeClass("show-on-load");
    }

    $(".show-on-load").fadeIn();
    $(".compare-swiper .loading")
      .delay(500)
      .fadeOut("slow");

    var boardheight = $(window).height() - 140;
    var boardwidth = Math.round(boardheight * 0.425);
    $(
      ".block-single-board .swiper-container, .block-single-board .swiper-slide"
    ).height(boardheight);

    $(".do-hide").on("click", function() {
      var $parent_board = $(this).parents(".this-board");
      var remove_index = $parent_board.index();

      $parent_board.animate(
        {
          width: 0,
        },
        function() {
          $parent_board.remove();
          var board_count = $(".this-board").length;
          if (board_count) {
            compareSwiper.reInit();
          } else {
            window.location.href = "/surfboards";
          }
        }
      );
    });

    // BOARD TOOLS
    // board_btn_actions();
    compare_view_attributes();
    fancy_selects();
    dims_listener();
    setup_compare_functionality();
    compare_view_tools();
    ci_tooltips();
  } // compare()

  function compare_layout() {
    /*
    console.log("compare layout");

    // console.log('compare layout');

    $(".compare-board-dims > img").height($(window).height() - 240);

    $(".compare-board-dims .dim-left").height(
      $(".compare-board-dims > img").height() - 50
    );

    // LAYOUT
    var boardheight = $(window).height() - 180;
    var slideheight = $(window).height() + $(".block-attributes").height() + 50;
    $(".compare-swiper .compare-board-dims").height(boardheight);
    $(".compare-board-view .swiper-container").height(slideheight);

    if (isMobile(true, false, 767)) {
      $(".compare-swiper .swiper-slide").width($(window).width());
    } else if (isMobile(true, false, 991)) {
      $(".compare-swiper .swiper-slide").width($(window).width());
    } else {
      if ($(".compare-swiper .swiper-slide").length == 2) {
        visibleboards = 2;
        $(".compare-swiper .swiper-slide")
          .width("50%")
          .height(slideheight);
      } else {
        $(".compare-swiper .swiper-slide")
          .width("33.3%")
          .height(slideheight);
      }
    }

    $(".compare-board-dims .dim-left").height(
      $(".compare-board-dims > img").height()
    );

    $(".compare-board-dims .dim-left").css({
      left:
        $(".compare-board-dims").width() / 2 -
        $(".compare-board-dims > img").width() / 2 -
        20 +
        "px",
    });
    $(".dim-dash").width($(".compare-board-dims > img").width() / 2);

    $(".compare-gradient").height($(window).height() - 72);
    $(".compare-gradient").height($(".compare-gradient").height());
    //$('.compare-gradient').width($('.compare-gradient').width()+1);
  }

  function compare_view_attributes() {
    console.log("compare_view_attributes");
    /// attributes
    $(".block-compare > .group-title").each(function(i, e) {
      if (isMobile()) {
        $(this).remove();
      }
      $(this).width($(window).width() - 80);
      var att_set = $(this).data("set");
      var placement = $(".attributes-group[data-set=" + att_set + "]").offset()
        .top;
      $(this).css("top", placement);
    });
    $(".block-compare .attributes-group .block-attribute").on(
      "mouseover",
      function() {
        $(".block-attribute").removeClass("active");
        var att = $(this).data("att");
        $(".block-attribute[data-att=" + att + "]").addClass("active");
      }
    );
    $("[data-set]").on("mouseover", function() {
      $(".attributes-group").removeClass("active");
      var att_set = $(this).data("set");
      $("[data-set=" + att_set + "]").addClass("active");
    });
    */
  }

  function compare_view_tools() {
    console.log("compare_view_tools");
    /// compare view tools
    $(".compare-tools .btn-dims-toggle").on("click", function() {
      $(".dim-wrap").fadeToggle();
    });
  }

  if ($("body").hasClass("compare-surfboards")) {
    before_compare();
    load_compare_boards(compare_list());
    $(window).on("changeState", function() {
      //before_compare();
      //load_compare_boards(compare_list());
    });
  }

  // -----------------------------------------------------
  // Scrolling Functions
  // -----------------------------------------------------
  var endless = false;

  $(window).scroll(function() {
    // Article Arrows
    if (
      $(this).scrollTop() >
      $(".block-post-cover").height() - $(window).height() / 2
    ) {
      $(".arrow").removeClass("out");
    } else {
      $(".arrow").addClass("out");
    }

    if ($("#nav-below").hasClass("endless")) {
      if (endless == false) {
        if (
          $(this).scrollTop() >
          $("#nav-below").offset().top -
            $(window).height() -
            $("article").height() * 2
        ) {
          var next_posts = $("#nav-below .pagination .next a").attr("href");
          if ($("#nav-below .pagination .next a").length > 0 ) {
            endless = true;
            $.get(next_posts, function(page) {
              newcontent = $(page)
                .find("#content")
                .html();
              $("#nav-below").remove();
              $("#content").append(newcontent);
              console.log('newcontent', newcontent);
              load_social_count();
              data_bg();
              endless = false;
            });
          } else {
            $("#nav-below").hide();
          }
        }
      }
    }

    if ($("body").hasClass("surfboards")) {
      if ($(this).scrollTop() > 60) {
        $("body").addClass("surfboards-scroll");
      } else {
        $("body").removeClass("surfboards-scroll");
      }
    }
  });

  // -----------------------------------------------------
  // Scrolling Functions
  // -----------------------------------------------------
  function load_social_count() {
    $("footer.entry-meta.empty-count").each(function(i, e) {
      var $footer = $(this);

      $.get(
        "http://www.cisurfboards.com/wp-content/themes/ci/lib/share_count/",
        {
          url: $footer.data("url"),
        },
        function(data) {
          if (data.shares.facebook > 0) {
            $footer
              .find(".facebook-social-count")
              .eq(0)
              .text(data.shares.facebook);
          }
          if (data.shares.twitter > 0) {
            $footer
              .find(".twitter-social-count")
              .eq(0)
              .text(data.shares.twitter);
          }
          $footer.removeClass("empty-count");
        }
      );
    });
  }
  load_social_count();

  // -----------------------------------------------------
  // Tabs
  // -----------------------------------------------------

  $("ul.tabs li a").click(function(e) {
    e.preventDefault();
    $(this)
      .parent("li")
      .addClass("active")
      .siblings("li")
      .removeClass("active");
    var tabtarget = $(this)
      .parents("ul.tabs")
      .attr("data-tab-target");
    var tabnum = $(this)
      .parent("li")
      .index();
    $("#" + tabtarget)
      .children(".tab-pane")
      .eq(tabnum)
      .addClass("active")
      .siblings(".tab-pane")
      .removeClass("active");
    $("#" + tabtarget)
      .find(".block")
      .addClass("out");
  });
  $("ul.tabs").each(function() {
    $(this)
      .find("li")
      .eq(0)
      .find("a")
      .trigger("click");
  });
  $("a.tabcontrol").click(function(e) {
    e.preventDefault();
    var tabtarget = $(this).data("tab-target");
    var tabnum = $(this).data("tab-num");
    $("#" + tabtarget)
      .children(".tab-pane")
      .eq(tabnum)
      .addClass("active")
      .siblings(".tab-pane")
      .removeClass("active");
    $("#" + tabtarget)
      .find(".block")
      .addClass("out");
  });

  // -----------------------------------------------------
  // Instagram Swiper
  // -----------------------------------------------------

  //    var socialSwiper = new Swiper3('.social-swiper', {
  //        mode: 'horizontal',
  //        loop: true
  //    });
  var socialSwiper = new Swiper(".social-swiper", {
    direction: "horizontal",
    loop: true,
    preloadImages: false,
    lazyLoading: true,
    nextButton: ".arrow-right",
    prevButton: ".arrow-left",
  });
  /*
    $('.arrow-left.social-arrow').on('click', function(e) {
        e.preventDefault;
        socialSwiper.swipePrev()
    });
    $('.arrow-right.social-arrow').on('click', function(e) {
        e.preventDefault;
        socialSwiper.swipeNext()
    });
    */

  // -----------------------------------------------------
  // ACCESSORIES BLOCK
  // -----------------------------------------------------

  var fromcarousel = false;
  var fromprofile = false;

  function accessories_swiper() {
    var accessoriesSwiper = new Swiper(".accessories-swiper", {
      mode: "horizontal",
      loop: true,
      initialSlide: 0,
      onSlideChangeEnd: function(swiper) {
        if (!fromcarousel) {
          fromprofile = true;
          var group = accessoriesSwiper.activeSlide().data("group");
          accessoriesCarousel.swipeTo(
            $(
              ".accessories-carousel .swiper-slide[data-group-first=" +
                group +
                "]"
            ).index()
          );
        }

        fromcarousel = false;
      },
    });
    $(".arrow-left.accessories-arrow").on("click", function(e) {
      e.preventDefault;
      accessoriesSwiper.swipePrev();
    });
    $(".arrow-right.accessories-arrow").on("click", function(e) {
      e.preventDefault;
      accessoriesSwiper.swipeNext();
    });

    $(".accessories-carousel .swiper-slide").width(600);

    var accessoriesCarousel = new Swiper(".accessories-carousel", {
      mode: "horizontal",
      loop: true,
      slidesPerView: isMobile(1, 3),
      centeredSlides: true,
      initialSlide: 1,
      visibilityFullFit: isMobile(),
      preventLinks: false,
      noSwiping: true,
      onSlideChangeEnd: function(swiper) {
        if (!fromprofile) {
          fromcarousel = true;
          var group = accessoriesCarousel.activeSlide().data("group");
          accessoriesSwiper.swipeTo(group);
        }
        fromprofile = false;
      },
    });
  }
  //accessories_swiper();

  // -----------------------------------------------------
  // MINI CART
  // -----------------------------------------------------

  // $.ajax({
  //     type: 'GET',
  //     url: shopify_shop_url+'cart.json',
  //     dataType: 'jsonp',
  //     success: function(data) {
  //         var item_count = data['item_count'];

  //         //If there are items in cart
  //         if(item_count > 0) {
  //             $('.cart-btn').addClass('active');
  //         } else {
  //             $('.cart-btn').removeClass('active');
  //         }
  //     }
  // });

  // $('.block-home-banner .swiper-container').each(function() {

  //     var homeSwiper = new Swiper('.block-home-banner .swiper-container', {
  //         mode: 'horizontal',
  //         loop: false,
  //         autoplay: 4000,
  //         pagination: '.home-pagination',
  //         paginationClickable: true,
  //         onSlideChangeEnd: function(swiper) {

  //             //var vid = homeSwiper.activeSlide().find('video');
  //             var vid = $('.block-home-banner .swiper-slide').eq(swiper.activeIndex).find('video')[0];
  //             if (typeof(vid) != 'undefined') {
  //                 vid.currentTime = 0;
  //                 vid.play();
  //             }
  //         },
  //         onSlideChangeStart: function(swiper) {
  // 						if( typeof $('.block-home-banner').find('video')[0] != 'undefined' ){
  //             $('.block-home-banner').find('video')[0].pause();
  // 						}
  //         }
  //     });

  // });

  // $('.block-post-cover .swiper-container').each(function() {
  //     var blogSwiper = new Swiper('.block-post-cover .swiper-container', {
  //         mode: 'horizontal',
  //         loop: true,
  //         autoplay: 4000,
  //         pagination: '.slideshow-pagination'
  //     });
  // });

  // -----------------------------------------------------
  // MEDIA COLLAGE
  // -----------------------------------------------------

  if (isMobile()) {
    // SWIPER

    $(".media-swiper")
      .addClass("swiper-container")
      .height($(window).height());
    $(".media-swiper .item .grid-item").hide();

    $(".media-swiper .grid-sizer").remove();
    $(".media-swiper").wrapInner('<div class="swiper-wrapper"></div>');
    $(".media-swiper").append(
      '<div class="media-pagination swiper-pagination"></div>'
    );
    $(
      ".media-swiper, .media-swiper .swiper-wrapper, .media-swiper .swiper-wrapper .item"
    )
      .width($(window).width())
      .height($(window).height());

    var mediaSwiper = new Swiper(".media-swiper", {
      mode: "horizontal",
      loop: true,
      pagination: ".media-pagination",
      paginationClickable: true,
      onInit: function(swiper) {
        $(".media-swiper .swiper-wrapper .item")
          .eq(0)
          .find(".grid-item")
          .fadeIn();
      },
      onTouchStart: function(swiper) {
        $(".media-swiper .swiper-wrapper .item")
          .eq(swiper.activeIndex)
          .find(".grid-item")
          .fadeIn();
      },
      onSlideChangeEnd: function(swiper) {
        var block = $(".media-swiper .item")
          .eq(swiper.activeIndex)
          .find(".grid-item");
        var dom_type = block.data("type");
        var media_src = block.data("full-media");
        if (dom_type == "iframe") {
          //iframe (video)
          block.fadeIn("slow");
        } else {
          //img
          $('<img style="display:none;" src="' + media_src + '"/>')
            .appendTo(block)
            .load(function() {
              block.css("background-image", "url(" + media_src + ")");
              block.fadeIn("slow");
            });
          $(".media-swiper .item")
            .eq(swiper.activeIndex)
            .find(".grid-item")
            .fadeIn();
        }
      },
    });

    $(".media-swiper .vid-item .icon-play").on("click", function() {
      $("body,html").animate({
        scrollTop: $(".media-swiper").offset().top,
      });

      $(".media-swiper").append('<div class="media-holder"></div>');
      $(".media-swiper .media-holder").fadeIn();
      $(".media-swiper .media-holder").append(
        '<button type="button" class="close close-photo" style="position:absolute; top:-10px;right:-10px;z-index: 999999;"><span class="icon-x-out"></span></button>'
      );

      var media_src = $(this)
        .parents(".vid-item")
        .data("full-media");

      $('<iframe src="' + media_src + '" frameborder="0" style="margin:0;" />')
        .width($(window).width() - 30)
        .height($(window).height() - 106)
        .appendTo(".media-swiper .media-holder")
        .load(function() {
          $(this).fadeIn("slow");
        });

      $(".media-holder .close-photo").on("click", function() {
        $(".media-holder").fadeOut("slow", function() {
          $(".media-holder iframe, .media-holder .close-photo").remove();
        });
      });
    });
  } else {
    // MASONRY

    var isoW = Math.ceil($(window).width() / 12) * 12,
      isoH = Math.ceil($(window).height() / 12) * 12;

    $(".masonry").width(isoW);
    //$('.masonry').height(isoH);

    $(".masonry").masonry({
      itemSelector: ".item",
      containerStyle: null,
      columnWidth: ".grid-sizer",
      gutter: 0,
    });

    var block;
    var isloading, hasloaded;

    $(".masonry .item:not(.active)").on("click", function() {
      if (!isloading) {
        isloading = true;
        hasloaded = false;

        block = $(this);
        block.toggleClass("active");
        var blocktop = block.offset().top - $(".masonry").offset().top;
        var blockleft = block.offset().left;
        var scale = $(window).width() / block.width();

        $("body,html").animate(
          {
            scrollTop: block.parents(".masonry").offset().top,
          },
          function() {
            if (!hasloaded) {
              $(".masonry").css({
                "-webkit-transform":
                  "translate3d(-" +
                  blockleft * scale +
                  "px, -" +
                  blocktop * scale +
                  "px, 0px) scale(" +
                  scale +
                  ", " +
                  scale +
                  ")",
                "-moz-transform":
                  "translate3d(-" +
                  blockleft * scale +
                  "px, -" +
                  blocktop * scale +
                  "px, 0px) scale(" +
                  scale +
                  ", " +
                  scale +
                  ")",
                transform:
                  "translate3d(-" +
                  blockleft * scale +
                  "px, -" +
                  blocktop * scale +
                  "px, 0px) scale(" +
                  scale +
                  ", " +
                  scale +
                  ")",
                "-webkit-transform-origin": "0% 0%",
                "-moz-transform-origin": "0% 0%",
                "transform-origin": "0% 0%",
              });
              $(".media-collage").append(
                '<button type="button" class="close close-photo" style="position:absolute; top:-10px;right:-10px;z-index: 999999;"><span class="icon-x-out"></span></button>'
              );
              $(".media-collage").append('<div class="media-holder"></div>');
              $(".media-collage .media-holder").fadeIn(function() {
                var dom_type = block.find(".grid-item").data("type");
                var media_src = block.find(".grid-item").data("full-media");

                if (dom_type == "iframe") {
                  $(
                    "<" +
                      dom_type +
                      ' src="' +
                      media_src +
                      '" frameborder="0" />'
                  )
                    .width($(window).width() - 120)
                    .height($(window).height() - 100)
                    .appendTo(".media-holder")
                    .load(function() {
                      $(this).fadeIn();
                    });
                  block.find("video")[0].pause();
                } else {
                  $(
                    '<img id="gallery_spotlight" src="' + media_src + '"/>'
                  ).appendTo(".media-holder");
                  $("#gallery_spotlight").load(function() {
                    var width = $(this)[0].clientWidth;
                    var height = $(this)[0].clientHeight;
                    console.log(width, height);
                    if (width > height) {
                      $(this).width("100%");
                      $(this).css("height", "auto");
                    } else {
                      $(this).height("100%");
                      $(this).css({
                        width: "auto",
                        "max-width": "none",
                      });
                    }
                    $(this)
                      .delay(200)
                      .fadeIn();
                  });
                }
              });
              masonry_listeners();
              hasloaded = true;
            }
          }
        );

        block.find(".zoom, .vid-item").fadeOut();
      } // if loading
    });

    $(".masonry .item .vid-item").hover(
      function() {
        $(this)
          .find("video")[0]
          .play();
      },
      function() {
        $(this)
          .find("video")[0]
          .pause();
      }
    );

    function masonry_listeners() {
      $(".close-photo").on("click", function() {
        $(".masonry").css({
          "-webkit-transform": "translate3d(0px, 0px, 0px) scale(1,1)",
          "-moz-transform": "translate3d(0px, 0px, 0px) scale(1,1)",
          transform: "translate3d(0px, 0px, 0px) scale(1,1)",
          "-webkit-transform-origin": "0% 0%",
          "-moz-transform-origin": "0% 0%",
          "transform-origin": "0% 0%",
        });
        block.find(".zoom, .vid-item").fadeIn();
        $(".close-photo").remove();
        $(".media-collage .media-holder").remove();

        isloading = false;
        hasloaded = false;
      });
    }
  } // if !mobile
  // end media collage

  // -----------------------------------------------------
  // Modals
  // -----------------------------------------------------

  $(".modal").on("show.bs.modal", function() {
    $("#global_container").addClass("blur");
  });
  $(".modal").on("hide.bs.modal", function() {
    $("#global_container").removeClass("blur");
  });

  ///prevent page scroll when scrolling dropdown
  $(".modal").bind("mousewheel DOMMouseScroll", function(e) {
    var e0 = e.originalEvent,
      delta = e0.wheelDelta || -e0.detail;

    this.scrollTop += (delta < 0 ? 1 : -1) * 30;
    e.preventDefault();
  });

  // -----------------------------------------------------
  // USER LOGINS
  // -----------------------------------------------------

  $("form.login").on("submit", function(e) {
    e.preventDefault();
    var $form = $(this);
    var posturl = $form.attr("action").replace("http", "http");
    var formdata = $form.serialize();
    $form.find(".alert").slideUp(function() {
      $(this).remove();
    });
    // console.log(formdata);
    $.post(
      posturl,
      formdata,
      function(data) {
        //console.log(data);

        if (data.ID > 0) {
          $("body")
            .addClass("logged-in")
            .data("user", data.ID);
          $(".modal-login").modal("hide");
          //$('.block-profile').load('/wp-content/themes/ci/profile.php?uid='+data.ID, function(){
          $(".block-profile").load("/empty.html", function() {
            $(".block-profile").load(
              "/wp-content/themes/ci/profile.php?cachebust=" + Math.random(),
              function() {
                openProfile();
                logout_listener();
                avatar_reload();
              }
            );
          });
        } else {
          if (data.ID == 0) {
            $form.submit();
          } else {
            $form.prepend('<p class="alert">' + data + "</p>");
            $("form.login .alert").slideDown();
          }
        }
        $("form.login .alert a").on("click", function(e) {
          e.preventDefault();
          $("#tab-login")
            .children(".tab-pane")
            .eq(2)
            .addClass("active")
            .siblings(".tab-pane")
            .removeClass("active");
        });
        if (data.caps.dealer) {
          //$('body').addClass('dealer');
          location.reload();
        } else {
          $("body").removeClass("dealer");
        }
      },
      "json"
    );

    if ($form.find("#email_opt_in").is(":checked")) {
      // New way
      var action = "http://apps.sltwtr.com/singlechimp/";

      var formdata = {};
      formdata.u = "cisurfboards";
      formdata.p = "b51e92741518d78a0c7922cc71662edc";
      formdata.l = "0617f92706";
      formdata.e = $form.find("#email").val();

      var str = "";
      for (var key in formdata) {
        if (str != "") {
          str += "&";
        }
        str += key + "=" + encodeURIComponent(formdata[key]);
      }
      str = str.replace("%40", "@");

      $.get(
        action,
        str,
        function(responsedata) {
          console.log("responsedata: ", responsedata);
        },
        "json"
      );

      /*  Old way
            $.post('/wp-content/themes/ci/lib/icontact/signup.php', {
                email: $form.find('#email').val()
            }, function(data) {
                console.log(data);
            },'json');
					*/
    }
  });

  // LOG OUT
  function logout_listener() {
    $(".logout").on("click", function() {
      $.post(
        "/wp-content/themes/ci/lib/ci/user.php",
        {
          action: "logout",
        },
        function() {
          closeProfile();
          $(".block-profile").load("/empty.html");
          $("body")
            .removeClass("logged-in")
            .data("user", "0");
        }
      );
    });
  }
  logout_listener();

  function avatar_reload() {
    $("iframe#avatar").attr(
      "src",
      "/wp-content/themes/ci/lib/ci/upload.php?uid=" + $("body").data("user")
    );
  }

  if (document.location.hash.search("social_login") > -1) {
    avatar_reload();
    openProfile();
  }

  // FORGOT PASSWORD
  $("form#forgotpassword").on("submit", function(e) {
    e.preventDefault();
    var $form = $(this);

    $.ajax({
      type: "POST",
      dataType: "json",
      url: "/wp-login.php?action=lostpassword",
      data: {
        action: "lostpassword",
        user_login: $("#forgotemail").val(),
      },
      success: function(data) {
        $form.prepend(
          '<p class="alert">Check your e-mail for the confirmation link.</p>'
        );
        $form.find(".alert").slideDown();
      },
      error: function(err, cool, rad) {
        $form.prepend(
          '<p class="alert">Check your e-mail for the confirmation link.</p>'
        );
        $form.find(".alert").slideDown();
      },
    });
  });

  /// CLOSE BUTTON
  $(".profile-header button.close").on("click", function() {
    closeProfile();
  });

  // PROFILE ACTIVATOR
  $("[data-toggle=profile]").on("click", function(e) {
    if ($("body").hasClass("logged-in")) {
      e.stopPropagation();
      openProfile();
    } else {
      $("#myProfile").modal("show");
    }
  });

  if (
    document.location.hash.search("account") > -1 ||
    document.location.hash.search("login") > -1 ||
    document.location.hash.search("signup") > -1
  ) {
    $("a#profile_btn").trigger("click");
    if (document.location.hash.search("signup") > -1) {
      setTimeout(() => {
        let $signupButton = $('#myProfile .nav-tabs li a:contains("Sign Up")');
        if ($signupButton.length) {
          $signupButton.trigger("click");
        }
      }, 100);
    }
  }

  // board page hash tag actions
  if ($("body").hasClass("single-board")) {
    if (document.location.hash.search("attributes") > -1) {
      $("body,html").animate({
        scrollTop: $(".details-attributes").offset().top,
      });
      let $button = $(
        '.block-single-details .details-cta .btn-group a:contains("Attributes")'
      );
      if ($button.length) {
        setTimeout(() => {
          $button.trigger("click");
          console.log("$button", $button.length);
        }, 4000);
      }
    }
    if (
      document.location.hash.search("comments") > -1 ||
      document.location.hash.search("reviews") > -1 ||
      document.location.hash.search("comment") > -1 ||
      document.location.hash.search("respond") > -1
    ) {
      $("#ciComments").modal("show");
    }
    if (document.location.hash.search("videos") > -1) {
      $("#ciComments").modal("show");
      $("#ciComments .tab-videos a").trigger("click");
    }
    if (document.location.hash.search("qa") > -1) {
      $("#ciComments").modal("show");
      $("#ciComments .tab-qa a").trigger("click");
    }
    if (document.location.hash.search("askaquestion") > -1) {
      $("#ciComments").modal("show");
      $("#ciComments .tab-qa a").trigger("click");
      setTimeout(() => {
        $('.comments-cta a[data-label="Ask Question"]').trigger("click");
        // $('.comments-cta a[data-label="Ask Question"]').scrollIntoView()
        $("#ciComments").animate({ scrollTop: 20000 }, "slow");
      }, 1000);
    }
    if (
      document.location.hash.search("dimensions") > -1 ||
      document.location.hash.search("dims") > -1
    ) {
      let $dimButton = $(".base-board-actions .do-stock-dims");
      if ($dimButton.length) {
        setTimeout(() => {
          $dimButton.trigger("click");
        }, 1000);
      }
    }
  }

  quiver_listeners();

  // -----------------------------------------------------
  // RIDER
  // -----------------------------------------------------

  if ($("section.rider-quiver").length > 0) {
    $(".quiver-profile").height($(window).height());

    if (isMobile()) {
      $(".block-quiver, .quiver-swiper, .quiver-swiper .swiper-slide").height(
        $(window).height()
      );

      // MOBILE QUIVER
      var quiverSwiper = new Swiper(".quiver-swiper", {
        mode: "horizontal",
        wrapperClass: "quiver-swiper-wrapper",
        loop: true,
        onSlideChangeEnd: function(swiper) {
          var bg = $(".quiver-swiper .swiper-slide")
            .eq(swiper.activeIndex)
            .data("color");
          $(".quiver-boards").css({
            "background-color": bg,
          });
        },
      });
    } else {
      // DESKTOP QUIVER
      $(".block-quiver ul li").height($(window).height());

      $(".quiver-profile").affix({
        offset: {
          top: $(".quiver-profile").offset().top,
          bottom: null,
        },
      });

      $(".block-quiver ul li").waypoint(
        function() {
          var bg = $(this).data("color");
          $(".quiver-boards").css({
            "background-color": bg,
          });
        },
        {
          offset: 200,
        }
      );
    }
  }

  // -----------------------------------------------------
  // COMMENTS
  // -----------------------------------------------------

  $(".comments-cta").on("click", function() {
    $this = $(this);
    $this.slideUp();
    $this.find("a").slideUp();
    $(".comment-form").val("");
    $(".comment-form-wrapper").slideDown();
    $(".comment-form")
      .find("#submit")
      .val($this.find("a").data("label"));
  });

  $(".comment-form").submit(function(e) {
    e.preventDefault();
    var $commentform = $(this);
    $commentform.parents(".comment-form-wrapper").slideUp();
    $.post($commentform.attr("action"), $commentform.serialize(), function(
      data
    ) {
      // console.log(data);
      $(".comments-cta")
        .find("a")
        .slideDown();
    });
  });

  // -----------------------------------------------------
  // PUBLIC QUIVER
  // -----------------------------------------------------

  /*
        $('.quiver-history > li').on('click', function() {
        console.log('clicked');
            if($(this).parents('#aProfile').hasClass('modal')){
                window.location.href = $(this).data('edit');
            }
        });
*/

  $("#aProfile").on("show.bs.modal", function(e) {
    setTimeout(function() {
      // $('#aProfile .quiver-history > li').on('click', function() {
      //     console.log('clicked');
      //     if($(this).parents('#aProfile').hasClass('modal')){
      //         //$(this).toggleClass('quiver-active').siblings('li').removeClass('quiver-active');
      //     }
      // });

      enable_product_cat_dropdowns();
    }, 1800);
  });

  var hashvars = document.location.hash.split("/");
  if (hashvars[0] == "#q") {
    $("#aProfile").modal({
      show: true,
      remote: "/wp-content/themes/ci/profile.php?ext=true&uid=" + hashvars[1],
    });
  }
  $(".do-quiver").on("click", function() {
    var qid = $(this).data("quiver");
    $("#aProfile").modal({
      show: true,
      remote: "/wp-content/themes/ci/profile.php?ext=true&uid=" + qid,
    });
  });
  $(document).on("hidden.bs.modal", ".modal:not(.local-modal)", function(e) {
    $(e.target)
      .removeData("bs.modal")
      .find(".modal-content")
      .empty();
    $(this).removeData("bs.modal");
  });

  // -----------------------------------------------------
  // TOOLTIPS
  // -----------------------------------------------------
  function ci_tooltips() {
    $("button.board-menu-toggle")
      .parent(".board-tooltip")
      .removeClass("board-tooltip-active");
    $("button.board-menu-toggle")
      .unbind("click")
      .on("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this)
          .parent(".board-tooltip")
          .toggleClass("board-tooltip-active");
      });

    $(".board-tooltip-menu .btn-tooltip,.btn, .attribute-level").tooltip(
      "hide"
    );
    $('[data-toggle="tooltip"]').tooltip("hide");

    $(".btn-dims-toggle-this").unbind("click");
    $(".btn-dims-toggle-this").on("click", function(e) {
      e.stopPropagation();
      $(this)
        .parents(".surf-grid > li, .compare-board")
        .find(".dim-wrap")
        .toggleClass("on");
    });

    if (isMobileDevice()) {
      $("[data-toggle=tooltip]").tooltip("destroy");
    }
  }
  ci_tooltips();

  // -----------------------------------------------------
  // SELECTABLE
  // -----------------------------------------------------

  $(".selectable .btn").on("click", function() {
    $(this)
      .addClass("btn-active")
      .siblings()
      .removeClass("btn-active");
  });

  // -----------------------------------------------------
  // SINGLE BOARD
  // -----------------------------------------------------

  // SHAPE3D
  $(".btn-customize").on("click", function() {
    $(".region-alert").addClass("in");
    var remove_region_timeout = setTimeout(function() {
      $(".region-alert").removeClass("in");
    }, 6000);
    $(".region-alert a.change-region")
      .unbind("click")
      .on("click", function() {
        clearTimeout(remove_region_timeout);
        $(".region-alert select").toggle();
      });

    $(".single-specs-wrapper").toggleClass("vertical-align");
    $(".block-single-specs").toggleClass("customize");
    $(".single-specs-wrapper .actions-group").toggle();
    if ($(this).hasClass("btn-active")) {
      $("body").addClass("customizing");
      $(".s3d-view-options.s3d-shape-options .btn-active").trigger("click");
      $(".block-single-switch .switch")
        .addClass("disabled")
        .fadeOut(function() {
          $(".block-single-switch .s3d-switches").fadeIn();
        });
      $(".block-single-board, .block-shape-3d").fadeOut(function() {
        $(".block-custom-board").fadeIn();
      });
      $(".block-single-switch").removeClass("");

      if (isMobile()) {
        $("body.customizing .single-board-view .single-specs-wrapper").css({
          "margin-top": $(window).height() - 167,
        });
        $("body,html").animate({
          scrollTop: 0,
        });
      }
    } else {
      $("body").removeClass("customizing");
      $(".block-custom-board").fadeOut(function() {
        $(".block-single-board").fadeIn();
        $(".block-single-switch .s3d-switches").fadeOut(function() {
          $(".block-single-switch .switch")
            .removeClass("switch-on")
            .removeClass("disabled")
            .fadeIn();
        });
      });

      $("body.customizing .single-board-view .single-specs-wrapper").css({
        "margin-top": 0,
      });

      if (isMobile()) {
        $(".single-board-view .single-specs-wrapper").css({
          "margin-top": 0,
        });
        $("body,html").animate({
          scrollTop: 0,
        });
      }

      $(".block-single-details").css("opacity", 1);
    }
    ga("send", "event", "Customize Button", "click", "button");
  });
  $(".customize-close").on("click", function() {
    $(".btn-customize").trigger("click");
  });

  // This is a great little jq func to go to next or first
  $.fn.nextOrFirst = function(selector) {
    var next = this.next(selector);
    return next.length ? next : this.prevAll(selector).last();
  };

  // On next button click, go to next tab
  $(".spec-cta .next-step").on("click", function(e) {
    var $activeTab = $(".customize-steps .btn-active");
    var $newActiveTab = $activeTab.nextOrFirst();
    //var $newActiveTab = $activeTab.next();
    $(".spec-cta .prev-step").show();
    if ($newActiveTab.is(":last-child")) {
      $(this).hide();
    }
    if ($activeTab.is(":last-child")) {
      console.log("last child");
      $(".do-complete").trigger("click");
    } else {
      console.log("next custom");
      $newActiveTab.trigger("click");
    }
  });

  // On next button click, go to next tab
  $(".spec-cta .prev-step").on("click", function(e) {
    show_or_hide_prev_button($(this));
  });

  function show_or_hide_prev_button($this) {
    $(".spec-cta .next-step").show();
    var $activeTab = $(".customize-steps .btn-active");
    var $newActiveTab = $activeTab.prev();

    if ($newActiveTab.is(":first-child")) {
      $this.hide();
    }
    if ($activeTab.is(":first-child")) {
      //$('.do-complete').trigger('click');
    } else {
      $newActiveTab.trigger("click");
    }
  }

  show_or_hide_prev_button($(".spec-cta .prev-step"));

  // END CUSTOMIZE

  $(".block-single-switch .switch").on("click", function() {
    alert("3d");
    $(".block-single-board, .block-shape-3d").fadeToggle();
  });

  // single board layout

  if ($("body").hasClass("single-board")) {
    if (isMobile()) {
      //mobile
      var boardheight = $(window).height() - 60;
      var boardwidth = Math.round(boardheight * 0.5);
      $(
        ".block-single-board, .block-single-board .swiper-container, .block-single-board .swiper-slide, .block-shape-3d"
      ).height(boardheight);
      $(".block-single-board .swiper-slide img").height(boardheight - 50);

      $(".block-shape-3d iframe").attr({
        src:
          $("iframe#s3dframe")[0].src +
          "&BoardWidth=" +
          Math.round(boardheight * 0.32) +
          "&BoardHeight=" +
          boardheight,
        width: boardwidth,
      });

      $(".block-single-switch").css("top", $(window).height() - 92 + "px");

      $(".do-toggle").on("click", function(e) {
        e.preventDefault();
        var toggle_this = $(this).data("toggle");
        $(toggle_this).slideToggle();
      });

      $(".loading.page-loader").fadeOut();
    } else {
      if ($("iframe#s3dframe").attr("id") == "s3dframe") {
        // desktop
        var boardheight = $(window).height() - 240;
        var $first_board_image = $(".block-single-board .swiper-slide")
          .eq(0)
          .find("img");
        var boardratio =
          $first_board_image.width() / $first_board_image.height();
        console.log(boardratio);
        var adjustedwidth = Math.round(boardheight * boardratio) + 60;
        var boardwidth = Math.round(boardheight * 0.425);
        $(
          ".block-single-board .swiper-container, .block-single-board .swiper-slide"
        ).height(boardheight);
        $(".block-single-board .swiper-slide img").height(boardheight - 70);

        $("iframe#s3dframe")
          .attr({
            height: boardheight + 60,
            width: boardwidth,
          })
          .css({
            height: boardheight + 60,
            width: boardwidth,
          })
          .attr(
            "src",
            $("iframe#s3dframe")[0].src +
              "&BoardWidth=" +
              adjustedwidth +
              "&BoardHeight=" +
              boardheight
          );

        // padding
        var details_pad =
          ($(window).height() - $(".details-fixed").height()) / 2;
        if (details_pad > 0) {
          $(".details-fixed").css({
            padding: details_pad + "px 0",
          });
        }
      }
      $(".loading.page-loader").fadeOut();
    }
  }

  // legacy board
  if ($("body").hasClass("page-template-page-legacy-surfboard-php")) {
    var boardheight = $(window).height() - 140;
    var boardwidth = Math.round(boardheight * 0.425);
    $(
      ".block-single-board .swiper-container, .block-single-board .swiper-slide"
    ).height(boardheight);
  }

  var boardSwiper = new Swiper(".single-board-swiper", {
    mode: "horizontal",
    loop: false,
  });

  $(".arrow-left.single-board-arrow").on("click", function(e) {
    e.preventDefault;
    boardSwiper.swipePrev();
  });
  $(".arrow-right.single-board-arrow").on("click", function(e) {
    e.preventDefault;
    boardSwiper.swipeNext();
  });

  // FADE IN SINGLE BOARD
  $(".container.this-board").css("opacity", 1);

  // single board actions
  $(".do-attributes").on("click", function() {
    $("body,html").animate({
      scrollTop: $(".details-attributes").offset().top,
    });
    ga("send", "event", "Attributes Button", "click", "button");
  });

  $(".do-comments").on("click", function() {
    $("#ciComments").modal("show");
    ga("send", "event", "Comments Modal", "click", "button");
  });

  $(".do-videos").on("click", function() {
    $("#ciComments").modal("show");
    $("#ciComments .tab-videos a").trigger("click");
    ga("send", "event", "Comments Modal", "click", "videos");
  });

  $(".do-stock-dims").on("click", function(e) {
    e.stopPropagation();
    $("#stockDims").modal("show");
    ga("send", "event", "Stock Dims Button", "click", "button");
  });

  $(".do-filters").on("click", function() {
    $("#ciFilters").modal("show");
  });

  if (document.location.hash == "#selector") {
    $("#ciFilters").modal("show");
  }

  $("#launch3D").on("click", function() {
    var iframe_src = $("#iframe3dBoard").data("src");
    $("#iframe3dBoard").attr("src", iframe_src);
    //$('#iframe3dBoard').attr('src', 'http://www.shape3d.com/Viewers/Viewer3D.aspx?Board=2537');

    $("#modalShape3d").modal("show");
    ga("send", "event", "Launch 3D", "click", "button");
  });

  ///prevent page scroll when scrolling dropdown
  $(".dropdown-menu").bind("mousewheel DOMMouseScroll", function(e) {
    var e0 = e.originalEvent,
      delta = e0.wheelDelta || -e0.detail;

    this.scrollTop += (delta < 0 ? 1 : -1) * 30;
    e.preventDefault();
  });

  // -----------------------------------------------------
  // SEARCH
  // -----------------------------------------------------

  $("#mySearch").on("shown.bs.modal", function(e) {
    $(".modal-search input#search").focus();
  });

  var typingTimer; //timer identifier
  var searchInterval = 1000; //time in ms, 5 second for example
  var doingsearch = false;

  $(".modal-search input#search").keyup(function() {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doSearch, searchInterval);
  });

  $(".modal-search input#search").keydown(function() {
    clearTimeout(typingTimer);
    $(".search-results h2, .search-result").hide();
  });

  $("#search_form").submit(function(e) {
    clearTimeout(typingTimer);
    doSearch();
    e.preventDefault();
    return false;
    //
  });

  function doSearch() {
    if (doingsearch == false) {
      doingsearch = true;

      //site
      $(".search-results .results-container")
        .empty()
        .load(
          "/search?q=" +
            encodeURIComponent($(".modal-search input#search").val()) +
            " .page-results",
          function() {
            $(".search-results h2, .results-container .search-result").each(
              function(i, e) {
                $(this)
                  .delay(i * 100)
                  .stop(true, true)
                  .fadeIn();
              }
            );

            // shop
            $(".search-results .shop-results-container")
              .empty()
              .load(
                "/search?q=" +
                  encodeURIComponent($(".modal-search input#search").val()) +
                  " .shop-results",
                function() {
                  $(
                    ".search-results h2, .shop-results-container .search-result"
                  ).each(function(i, e) {
                    $(this)
                      .delay(i * 100)
                      .fadeIn();
                  });

                  //blog
                  $(".search-results .blog-results-container")
                    .empty()
                    .load(
                      "/search?q=" +
                        encodeURIComponent(
                          $(".modal-search input#search").val()
                        ) +
                        " .blog-results",
                      function() {
                        $(
                          ".search-results h2, .blog-results-container .search-result"
                        ).each(function(i, e) {
                          $(this)
                            .delay(i * 100)
                            .fadeIn();
                        });

                        doingsearch = false;
                      }
                    );
                }
              );
          }
        );
    }
  }

  // -----------------------------------------------------
  // PARALLAX
  // -----------------------------------------------------
  $(window).scroll(function() {
    $(".block-team-title").css({
      "margin-top": $(window).scrollTop() / 3,
    });
    if (
      $(window).scrollTop() + $(window).height() + 30 >=
      $(document).height()
    ) {
      $("body").addClass("bottom");
    } else {
      $("body").removeClass("bottom");
    }
  });

  // -----------------------------------------------------
  // SINGLE POST
  // -----------------------------------------------------
  $(".block-post-cover .video-play").on("click", function() {
    $("body,html").animate({
      scrollTop: $(".block-post-cover").offset().top,
    });
    $(this).fadeOut("slow", function() {
      $(".block-post-cover").append(
        '<button type="button" class="close close-photo" style="position:absolute; top:-10px;right:-10px;z-index: 999999;"><span class="icon-x-out"></span></button>'
      );
      var media_src = $(this).data("full-media");
      $(
        '<iframe src="' +
          media_src +
          '" frameborder="0" style="margin:50px 60px;" />'
      )
        .width($(window).width() - 120)
        .height($(window).height() - 100)
        .appendTo(".block-post-cover")
        .load(function() {
          $(this).fadeIn("slow");
        });
      $(".block-post-cover .close-photo").on("click", function() {
        $(".block-post-cover iframe").fadeOut("slow", function() {
          $(
            ".block-post-cover iframe, .block-post-cover .close-photo"
          ).remove();
          $(".block-post-cover .video-play").fadeIn();
        });
      });
    });
  });

  // -----------------------------------------------------
  // FOOTER
  // -----------------------------------------------------

  $(".footer-toggle").on("click", function() {
    $(".footer-nav").slideToggle();
    $("body,html").animate({
      scrollTop: $(".footer-nav").offset().top,
    });
  });

  $(".facebook-like-button").empty();
  $(".fb-like").appendTo(".facebook-like-button");

  // -----------------------------------------------------
  // USER DIMS
  // -----------------------------------------------------

  

	// function board_volume() {
	// 	clog('get volume');
 //        $.ajax({
 //            method: "POST",
 //            url: "http://app.shape3d.com/Shape3dWeb/BoardDesigner/BDWebService.asmx",
 //            data: {
 //                board: JSON.stringify('10'),
 //                length: JSON.stringify('72"'),
 //                width: JSON.stringify('19 1/2"'),
 //                thickness: JSON.stringify('2 1/2"'),
 //                railperc: JSON.stringify('0'),
 //                unite: JSON.stringify('IF')
 //            },
 //            contentType: "application/json; charset=utf-8",
 //            dataType: "json",
 //            success: function (data, status) {
 //            	clog(data);
 //                $('.user-dims .volume-value').html(JSON.stringify(data.d));
 //            },
 //            error: function (request, status, error) {
 //                alert("Error:" + request.statusText + " " + error);
 //            }

 //        });
	// 	clog('get volume');
 //    }
    //GetVolume();

	// $('.user-dims select').change(function(e){
 //    if($(e.target).parents(".user-dims").find('.board-select-4 button').hasClass('btn-active')){
 //      alert('fixed vol')
 //    } else {
	// 	  board_volume($(e.target));
 //    }
	// });
	

  /// USER SPECS

  function board_volume($this) {
    var dims_block = $this.parents(".board-dims");
    var dims_data = {
      board: dims_block[0].dims.s3did,
      length: dims_block.find("select.select-length").val(),
      width: dims_block.find("select.select-width").val(),
      thickness: dims_block.find("select.select-thickness").val(),
      railperc: 0,
      unite: "IF",
    };
    //$.post('http://www.shape3d.com/api/volume', dims_data, function(data) {
    $.post("https://www.shape3d.com/api/volume", dims_data, function(data) {
      var volume = data.toFixed(1);
      dims_block.find(".field-volume").text(volume + " L");
    });
  }

  function board_fixed_volume(fixed) {

    console.log('fixed volume', this)

    var changed_dim = fixed.data("dim");
    var dims_block = fixed.parents(".board-dims");
    var fixed_dim;
    console.log("changed_dim: ", changed_dim);

    dims_block.find("select").each(function(i, e) {
      if ($(this).data("dim") != changed_dim) {
        if (
          !$(this)
            .next(".btn-group")
            .hasClass("dim-locked")
        ) {
          fixed_dim = $(this).data("dim");
        }
      }
    });

    console.log("fixed_dim: ", fixed_dim);

    function dim(dim) {
      if (dim) {
        return dim;
      } else {
        return 0;
      }
    }

    s3d_vol_data = {
      board: dims_block[0].dims.s3did,
      length: dim(dims_block.find("select.select-length").val()),
      width: dim(dims_block.find("select.select-width").val()),
      thickness: dim(dims_block.find("select.select-thickness").val()),
      fixedvol: $(".field-volume")
        .val()
        .replace(" L", ""),
      adjusteddim: fixed_dim, // dims_block.find('dim-locked').data('dim'),
      prec: dims_block
        .find("select.select-" + fixed_dim.toLowerCase())
        .data("prec"), // dims_block.find('dim-locked').data('dim'),
      railperc: 0,
      unite: "IF",
    };

    $.post("https://www.shape3d.com/api/fixedvolume", s3d_vol_data, function(
      data
    ) {
      console.log("fixed data: ", data);
      var decimal_value = decimal(data.replace('"', ""));
      programatic_change = true;
      changeSelect(
        dims_block.find("select.select-" + fixed_dim.toLowerCase()),
        decimal_value
      );
    });
  }

  function dims_listener() {
    $dims_divs = $(".select-length, .select-width, .select-thickness");
    $dims_divs.find("ul li a").on("click", function(e) {
      console.log("clicked dim");
      programatic_change = false;
    });

    $(".board-dims select").on("change", function(e) {
      // console.log("dim change");
      console.log("programatic_change: ", programatic_change);
      if (!programatic_change) {
        if (
          $(this)
            .parents(".board-dims")
            .hasClass("locked")
        ) {
          board_fixed_volume($(e.target));
        } else {
          board_volume($(this));
        }
      }
      set_dim_lines($(this).parents(".board-dims"));

      modify_compare($(this).parents(".this-board"));
    });
  }
  // dims_listener();

  $(".dim-wrap").click(function(e) {
    e.stopPropagation();
    $("#ciRockers").modal("show");
  });

  /*
        if ($('body').hasClass('surfboards')) {

            // nose rocker
            $.post('https://www.shape3d.com/api/rocker', {
                    board: $user_dims.data('sd'),
                    length: dimlength,
                    prec: '1/16',
                    position: dimlength, //distance from tail
                    unite: 'IF'
                },
                function(data) {
                    console.log(data);
                    $thisboard.find('.nose-rocker').text(data.replace('"', ''));
                }
            );


            /// nose rocker
            $.post('https://www.shape3d.com/api/rocker', {
                    board: $user_dims.data('sd'),
                    length: dimlength,
                    prec: '1/16',
                    position: 0, //distance from tail
                    unite: 'IF'
                },
                function(data) {
                    console.log(data);
                    $thisboard.find('.tail-rocker').text(data.replace('"', ''));
                }
            );

        }
        */

  /// LOCKED VOLUME
  $(".board-dims .btn-fixed-volume").on("click", function() {
    $(this)
      .parents(".board-dims")
      .toggleClass("locked");
    $("div.select-length")
      .addClass("dim-locked")
      .siblings("div.select")
      .removeClass("dim-locked");
  });

  $(".board-dims").addClass("locked");
  $(".board-dims.locked div.select").on("click", function(e) {
    if ($(this).hasClass("dim-locked")) {
      $(this).remove("open");
    }
    var div = $(this)[0];
    if (e.offsetY < div.offsetHeight - $(this).height()) {
      $(this)
        .addClass("dim-locked")
        .siblings("div.select")
        .removeClass("dim-locked");
    }
  });
  $(".board-dims").removeClass("locked");

  if ($("body").hasClass("page-template-page-legacy-surfboard-php")) {
    var details_pad = ($(window).height() - $(".details-fixed").height()) / 2;
    if (details_pad > 0) {
      $(".details-fixed").css({
        padding: details_pad + "px 0",
      });
    }
  }

  // -----------------------------------------------------
  // Univeral Analytics
  // -----------------------------------------------------

  $(".swiper-no-swiping .btn-addtocart").on("click", function() {
    ga("send", "event", "Related Product", "click", "product");
  });

  $(".select-length").on("click", function() {
    ga("send", "event", "Select Length", "click", "filters");
  });

  $(".select-width").on("click", function() {
    ga("send", "event", "Select Width", "click", "filters");
  });

  $(".select-thickness").on("click", function() {
    ga("send", "event", "Select Thickness", "click", "filters");
  });

  $("#Button_Resize").on("click", function() {
    ga("send", "event", "Custom Shape", "click", "custom");
    console.log("Button Custom Shape");
  });

  $("#Button_Setup").on("click", function() {
    ga("send", "event", "Custom Set Up", "click", "custom");
  });

  $("#Button_Graphics").on("click", function() {
    ga("send", "event", "Custom Graphics", "click", "custom");
  });


  if ($("body").hasClass("gift")) {
    $(".gift-email").focus();
    $(".gift-email-submit").on("click", function(e) {
      e.preventDefault();

      var qid = 0;
      $.post(
        "/wp-content/themes/ci/lib/ci/api.php",
        {
          scope: "user",
          action: "get_user_id",
          user_email: $(".gift-email").val(),
        },
        function(data) {
          qid = data;
          if (qid > 0) {
            $("#aProfile").modal({
              show: true,
              remote: "/wp-content/themes/ci/profile.php?ext=true&uid=" + qid,
            });
          } else {
            alert("Invalid email, please try again.");
          }
        }
      );
    });
  }

  $(".board-modal-trigger").on("click", function() {
    /*
        var $this = $(this);
        var bmt_left = $this.offset().left + 50;
        var bmt_top = $this.offset().top - $(window).scrollTop() + 50;
        console.log(bmt_left, bmt_top);
        $('.board-modal').css({
            'left':bmt_left+'px',
            'top':bmt_top+'px'
        });
        setTimeout(function(){
            $('.board-modal').addClass('animate').removeClass('inactive').css({
                'left':'0px',
                'top':'0px'
            });
        },200);
        */
    var $this = $(this);
    $(".board-modal").removeClass("inactive");
    $(".board-modal .accessories-content").html(
      $this
        .parents(".swiper-slide")
        .find(".accessories-holder")
        .html()
    );
    $(".board-modal .board-content").load(
      "/wp-content/themes/ci/featured-board.php?bid=" + $this.data("remote"),
      function() {
        $("img[data-src]").load(function() {
          $(this).css("opacity", 1);
        });
        $("img[data-src]").waypoint(
          function(i, e) {
            $(this).attr("src", $(this).data("src"));
          },
          {
            offset: "90%",
          }
        );
        enable_product_cat_dropdowns();
        accessories_swiper();
        fancy_selects();
        board_btn_actions();
        setup_compare_functionality();

        $(".board-modal .close")
          .unbind("click")
          .on("click", function() {
            $(".board-modal").toggleClass("inactive");
            $(".board-modal .board-content").empty();
          });
      }
    );
  });

  function no_localhost() {
    /*
        $("a").each(function(){
            if()
            var newUrl = $(this).attr('href').replace('.localhost', '');
            $(this).attr('href', newUrl);
        });
        $("img").each(function(){
            var newUrl = $(this).attr('src').replace('.localhost', '');
            $(this).attr('src', newUrl);
        });
        $("img").each(function(){
            var newUrl = $(this).attr('data-src').replace('.localhost', '');
            $(this).attr('data-src', newUrl);
        });
*/
  }
  no_localhost();
});

function quiver_listeners() {
  $(".block-profile .quiver-history > li")
    .unbind("click")
    .on("click", function() {
      $(this)
        .toggleClass("quiver-active")
        .siblings("li")
        .removeClass("quiver-active");
    });
  $(".block-profile .quiver-history .btn")
    .unbind("click")
    .on("click", function(e) {
      e.stopPropagation();
    });

  $("input.copy-text")
    .focus(function() {
      $(this).select();
    })
    .mouseup(function(e) {
      e.preventDefault();
    });

  $(".block-profile .quiver-history > li .board-remove")
    .unbind("click")
    .on("click", function() {
      var $this = $(this);
      $this.parents("li.quiver-item").slideUp();
      $.post(
        "/wp-content/themes/ci/lib/ci/remove_from_quiver.php",
        {
          user: $("body").data("user"),
          shape3d_id: $this.data("s3d"),
        },
        function(data) {
          $(".block-profile").load(
            "/wp-content/themes/ci/profile.php?rand=" +
              Math.random() +
              "&uid=" +
              $("body").data("user"),
            function() {
              quiver_listeners();
            }
          );
        },
        "json"
      );
    });
}

// OPEN PROFILE
function openProfile() {
  $(".block-profile").show();
  $("body").addClass("profile_open");
  $("#global_container").addClass("blur");
  $("#global_container").append('<div class="blur-overlay"></div>');
  $("html,body").css({
    height: "100%",
    overflow: "hidden",
  });
  $("#global_container .blur-overlay").on("click", function() {
    if ($("body").hasClass("profile_open")) {
      closeProfile();
    }
  });

  //setup before functions
  var typingTimer; //timer identifier
  var doneTypingInterval = 2000; //time in ms, 5 second for example
  //on keyup, start the countdown
  $(".profile-header .profile-name").keyup(function() {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(updateUser, doneTypingInterval);
  });
  $(".profile-header .profile-name").keydown(function() {
    clearTimeout(typingTimer);
  });
  var updatinguser = false;

  function updateUser() {
    if (!updatinguser) {
      updatinguser = true;
      $.post(
        "/wp-content/themes/ci/lib/ci/user.php",
        {
          action: "update",
          uid: $("body").data("user"),
          display_name: $(".profile-header .profile-name").html(),
          height:
            parseInt($(".profile-header select#height_feet").val()) * 12 +
            parseInt($(".profile-header select#height_inches").val()),
          weight: $(".profile-header select#weight").val(),
          ability: $(".profile-header select#ability").val(),
        },
        function(data) {
          updatinguser = false;
          updateDims();
        }
      );
    }
  }

  $(
    ".profile-header select#weight, .profile-header select#ability, .profile-header select#height_feet, .profile-header select#height_inches"
  ).unbind("change");

  $(".profile-header select#weight").on("change", function() {
    updateUser();
    $("#weight_label").text($("select#weight").val() + " LBS");
  });
  $(".profile-header select#ability").change(function() {
    updateUser();
    $("#ability_label").text($(this).val());
  });
  $(
    ".profile-header select#height_feet, .profile-header select#height_inches"
  ).change(function() {
    updateUser();
    $("#height_label").text(
      $(".profile-header select#height_feet").val() +
        "' " +
        $(".profile-header select#height_inches").val()
    );
  });

  $(".quiver-additional p").keyup(function() {
    var $comment = $(this);
    clearTimeout(typingTimer);
    typingTimer = setTimeout(function() {
      $.post(
        "/wp-content/themes/ci/lib/ci/user.php",
        {
          action: "quiver_comment",
          uid: $("body").data("user"),
          comment: $comment.html(),
          q_index: $comment.index(),
        },
        function(data) {
          clog(data);
        }
      );
    }, doneTypingInterval);
  });
  $(".quiver-additional p").keydown(function() {
    clearTimeout(typingTimer);
  });

  $("iframe#avatar").load(function() {
    $(".select-profile").load(
      "/wp-content/themes/ci/lib/ci/avatar.php?uid=" + $("body").data("user")
    );
  });

  /*
    $('.profile-header .profile-img img').on('click',function(){
        var profile_img = $(this);
        profile_img.hide();
        $('.profile-header .profile-img').append('<iframe frameborder="0" scrolling="no" src="/wp-content/themes/ci/lib/ci/upload.php"></iframe>');
        var frame_loaded = false;
        $('.profile-header .profile-img iframe').load(function(){
            if(frame_loaded == false){
                frame_loaded == true;
            } else {
                $('.profile-header .profile-img').load('/wp-content/themes/ci/lib/ci/upload.php?uid'+$('body').data('user'));
            }
        });
        $('#basic-local-avatar').trigger('click');
    });
    $('#basic-local-avatar:file').change(function(){
        var $this = $(this);
        setTimeout(function(){
            $this.parents('form').submit();
        },1000);
    });
    $('#basic-user-avatar-form').attr('target','avatar_loader');
    */

  $(".quiver-comments").unbind("click");
  $(".quiver-comments").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    var comment = $(this)
      .parent("ul")
      .next(".additional");
    comment.slideToggle();
    comment.find("p").focus();
  });

  $(".quiver-history > li").unbind("click");

  $(".quiver-history > li").on("click", function() {
    /*
        if($(this).parents('#aProfile').hasClass('modal')){
            window.location.href = $(this).data('edit');
        }
        */
    $(this)
      .toggleClass("quiver-active")
      .siblings("li")
      .removeClass("quiver-active");
  });

  /// CLOSE BUTTON
  $(".profile-header button.close").on("click", function() {
    closeProfile();
  });
}

// CLOSE PROFILE
function closeProfile() {
  $("#global_container").removeClass("blur");
  $("body").removeClass("profile_open");
  $("#global_container .blur-overlay").remove();
  $("#global_container.blur").unbind("click");
  $("html,body").css({
    height: "auto",
    overflow: "scroll",
  });
}
